module.exports = __webpack_public_path__ + "static/media/home-streamer-tiles.ed0d23e0.png";